import { FC } from 'react'
import { Amount } from '@root/api/ump-ewallet'
import { Payee } from '@root/api/ump-catalog-manager'

export enum TSP {
  ComboBox = 'ComboBox',
  Vouchers = 'Vouchers',
  Banner1 = 'bannerweb1',
  Banner2 = 'bannerweb2',
}

export enum PayStatusSBP {
  WAIT = 'RCVD',
  // NOT_FOUND = 10,
  ACCEPTED = 'ACWP',
  REJECTED = 'RJCT',
}

export enum PaymentType {
  SBP = 'SBP',
  MTSCARD = 'MTS_bank',
}

export interface GetPriceResp {
  price?: string
}

export interface FetchQR {
  qrcId: string
  payload: string
}

export interface FetchQRStatus {
  processTime: string
  state: string
  stateQr: string
  qrcId: string
  serviceId: number
  amount: {
    base?: number
    fee?: number
    total?: number
    currency: string
  }
  paymentPurpose?: string
  recipientInfo: {
    account: string
    email: string
  }
  operationId: string
}

export interface PaymentBlockInfo {
  type: PaymentType
  buttonVariant: 'redDark' | 'red'
  terms: boolean
  InfoComponent: FC<{ fee?: string }>
}

export enum ESteps {
  SERVICES_FORM = 'SERVICES_FORM',
  PAYMENT_FORM = 'PAYMENT_FORM',
  PAYMENT_OTP = 'PAYMENT_OTP',
  SERVICE_PAYMENT_ERROR = 'SERVICE_PAYMENT_ERROR',
  SBP_PAYMENT_RESULT = 'SBP_PAYMENT_RESULT',
  SBP_LOADING = 'SBP_LOADING',
  SERVICE_PAYMENT_NOT_MONEY = 'SBP_SERVICE_PAYMENT_NOT_MONEY',
  NOT_TCP = 'NOT_TCP',
}

export interface VouchersFormValues extends PaymentValues {
  email: string
  phone: string
  uid: string
  id: string
  zoneId: string
  server: string
  uidPubg?: string
  playerId: string
}

export interface PubgFormValues extends PaymentValues {
  uidPubg: string
}

export interface GenshinFormValues extends PaymentValues {
  uid: string
  server: string
}

export interface AccountFormValues extends PaymentValues {
  login: string
  price: string
  priceDollar: string
  phone: string
  email: string
}

export interface PurchaseFormValues extends PaymentValues {
  promocode: string
  login: string
  price: string
  priceDollar: string
  phone: string
  email: string
  uid: string
  server: string
  uidPubg: string
  id: string
  zoneId: string
  playerId: string
}

export type PaymentValues = {
  isCardPayment: boolean
  amountInfo: Amount
  serviceInfo: Payee
}

export interface PaymentResultProps {
  isNeedFinish3ds?: boolean
  paRes?: string
  cRes?: string
}

export interface ICourseSteam {
  account_status: string
  usd_topup: string
  rub_topup: string
  kzt_topup: string
}

export enum ContentType {
  'LOADING' = 'loading',
  'ERROR' = 'error',
  'CONTENT' = 'content',
}

export enum Status {
  SUCCESS = 'Success',
  WAIT = 'Wait',
  FAIL = 'Fail',
}

export const statusCodes = {
  [Status.SUCCESS]: [2, 3, 4],
  [Status.WAIT]: [5, 7],
  [Status.FAIL]: [6, 8],
}

export const stateMapper = {
  [Status.FAIL]: 'REJECTED',
  [Status.WAIT]: 'PROCESSING',
  [Status.SUCCESS]: 'PROCESSED',
}

export enum ConfirmationType {
  OTP_SMS_CALLBACK = 'OTP_SMS_CALLBACK',
  OTP_PAYMENT_PAGE = 'OTP_PAYMENT_PAGE',
  FINISH_3DS = 'FINISH_3DS',
  FINISH_3DS2 = 'FINISH_3DS2',
}

export enum Tabs {
  GAMES = 'Пополнение игр',
  SERVICES = 'Сервисы',
  PROGRAMS = 'Программы',
  TOP = 'Топ-сервисы',
}

export interface countryVouchers {
  country: string
  icon: string
  tooltip?: React.ReactElement
}

export interface FetchInarius {
  success: boolean
  message: string
}

export enum PaymentMethod {
  SBP = 'SBP',
  MTS_ACCOUNT = 'MTS_ACCOUNT',
}
